import { render, staticRenderFns } from "./TransactionDelete.vue?vue&type=template&id=2b04627a&scoped=true"
import script from "./TransactionDelete.vue?vue&type=script&lang=js"
export * from "./TransactionDelete.vue?vue&type=script&lang=js"
import style0 from "./TransactionDelete.vue?vue&type=style&index=0&id=2b04627a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04627a",
  null
  
)

export default component.exports